import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Typography,
  Autocomplete,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Dialog,
  RadioGroup,
  FormControlLabel,
  Radio,
IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { insertFacts } from "../../../../../store/slices/facts";
import _ from "lodash";
import { locationsSelector } from "../../../../../store/slices/location";
const factsLimit=4000
const Details = ({ open, setOpen,companyId, reviewId}) => {
  const dispatch = useDispatch();
  const [factValue, setFactValue] = useState("");
  const [radioValue, setRadioValue] = useState("location");
  const [locationValue, setLocationValue] = useState([]);
  const [brandsValue, setBrandsValue] = useState([]);
  const [regionsValue, setRegionsValue] = useState([]);
  const [errorValidation, setErrorValidation] = useState(false);
  // const { locations } = useSelector(settingsSelector);
  const { brands, regions,locations } = useSelector(locationsSelector);
  const locationsList = React.useMemo(() => {
    let dataList = [];

    if (locations) {
      _.map(_.sortBy(locations,'name'), (location) => {
        let data = { value: location.locationId, label: location.name };
        dataList.push(data);
      });
    }

    return _.uniqBy(dataList, "value");
  }, [locations]);

  const brandsList = useMemo(() => {
    return _.map(_.sortBy(brands,'name'), (it) => ({ value: it?.brandId, label: it?.name }));
  }, [brands]);
  const regionsList = useMemo(() => {
    return _.map(_.sortBy(regions,'name'), (it) => ({ value: it?.regionId, label: it?.name }));
  }, [regions]);
  const onClose = () => {
    setOpen(false);
  };
  const onSave = () => {
    let data = {};
    if (factValue?.length > 0 && factValue?.length <= factsLimit) {
      const entityTypeIds =
        (_.size(locationValue) > 0 ||
        _.size(brandsValue) > 0 ||
        _.size(regionsValue) > 0)
          ? radioValue === "location"
            ? _.map(locationValue, (it) => it.value)
            : radioValue === "brand"
            ? _.map(brandsValue, (it) => it.value)
            : radioValue === "region"
            ? _.map(regionsValue, (it) => it.value)
            : null
          : null;

      data = {
        companyId: companyId,
        entityType: _.startCase(radioValue),
        entityIds: entityTypeIds,
        fact: factValue,
      };

      dispatch(insertFacts(data,reviewId));
      setErrorValidation(false);
      onClose();
    } else setErrorValidation(true);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">Add Fact</Typography>
          <IconButton color="secondary" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Grid columns={6} container spacing={3} sx={{ pt: 2, px: 1 }}>
          <Grid item xs={1}sx={{alignItems:'center',display:'flex'}}>
            <Typography variant="subtitle1">Associate with</Typography>
          </Grid>
          <Grid item xs={5}>
            <RadioGroup
              aria-labelledby="append-with-radio-group-label"
              // defaultValue="location"
              name="append-with-group"
              row
              value={radioValue}
              onChange={(e) => setRadioValue(e.target.value)}
              size="small"
            >
              <FormControlLabel
                size="small"
                value="location"
                control={<Radio size="small" />}
                label="Locations"
              />
              <FormControlLabel
                size="small"
                value="brand"
                control={<Radio size="small" />}
                label="Brands"
              />
              <FormControlLabel
                size="small"
                value="region"
                control={<Radio size="small" />}
                label="Regions"
              />
            </RadioGroup>
          </Grid>
          {radioValue === "location" && (
            <>
              <Grid item xs={1}sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Locations</Typography>
              </Grid>
              <Grid item xs={5}>
                {/* <Autocomplete
      multiple
        disableClearable
        options={locationsList?.map(a=>a.label)}
        getOptionLabel={(option) => option.label}
        fullWidth
        renderInput={(params) => (
          <TextField {...params} label="Location" />
        )}
        value={locationValue}
        onChange={(e, newValue) => setLocationValue(newValue)}
      /> */}
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  limitTags={3}
                  id="tags-standard"
                  options={locationsList}
                  onChange={(e, newValue) => setLocationValue(newValue)}
                  getOptionLabel={(option) => option.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          {radioValue === "brand" && (
            <>
              <Grid item xs={1}sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Brands</Typography>
              </Grid>
              <Grid item xs={5}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  limitTags={3}
                  id="tags-standard"
                  options={brandsList}
                  onChange={(e, newValue) => setBrandsValue(newValue)}
                  getOptionLabel={(option) => option.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          {radioValue === "region" && (
            <>
              <Grid item xs={1}sx={{alignItems:'center',display:'flex'}}>
                <Typography variant="subtitle1">Regions</Typography>
              </Grid>
              <Grid item xs={5}>
                <Autocomplete
                  multiple
                  fullWidth
                  disableCloseOnSelect
                  limitTags={3}
                  id="tags-standard"
                  options={regionsList}
                  onChange={(e, newValue) => setRegionsValue(newValue)}
                  getOptionLabel={(option) => option.label}
                  // defaultValue={[top100Films[13]]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // variant="standard"

                      placeholder="Search"
                    />
                  )}
                />
              </Grid>
            </>
          )}
          <Grid item xs={1}>
            <Typography variant="subtitle1">Fact</Typography>
          </Grid>
          <Grid item xs={5}>
            <TextField
              value={factValue}
              onChange={(e) => setFactValue(e.target.value)}
              multiline
              rows={6}
              fullWidth
              inputProps={{ maxLength: factsLimit }}
              error={
                factValue?.length >= factsLimit ||
                (factValue?.length === 0 && errorValidation)
              }
            />
            {factValue?.length >= factsLimit && (
              <Typography
                sx={{ position: "absolute" }}
                vairant="caption"
                color={"error"}
              >
                Facts Should not be more than {factsLimit} words!
              </Typography>
            )}
            {errorValidation && factValue?.length === 0 && (
              <Typography
                sx={{ position: "absolute" }}
                vairant="caption"
                color={"error"}
              >
                Facts cannot be empty!
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          mx: 3,
          pb: 3,
          borderTop: (theme) => `1px solid ${theme.palette.divider}`,
          position: "relative",
        }}
      >
        <Button variant="contained" sx={{ width: "140px" }} onClick={onSave}>
          Save
        </Button>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Details;
